module.exports = __webpack_public_path__ + "static/Ankheg-5e959bb24cbcbf639e5fe3dfdf5d9563.jpg";